export function h(tag: string | Function, props: any, ...children: any[]): HTMLElement {
  if (typeof tag === "function") {
    return tag({ ...props, children });
  }

  const el = document.createElement(tag);

  for (const [key, value] of Object.entries(props || {})) {
    if (key === "ref" && typeof value === "function") {
      value(el);
    } else if (key.startsWith("on") && typeof value === "function") {
      el.addEventListener(key.slice(2).toLowerCase(), value as EventListener);
    } else if (key === "className") {
      el.className = value as string;
    } else {
      el.setAttribute(key, String(value));
    }
  }

  for (const child of children.flat()) {
    if (typeof child === "string" || typeof child === "number") {
      el.appendChild(document.createTextNode(child.toString()));
    } else if (child instanceof Node) {
      el.appendChild(child);
    }
  }

  return el;
}


  export const Fragment = (_props: { children: any }) => _props.children;

